import presets from './presets'

// モーダルダイアログのHTML生成
function createDialogElement(preset, index) {
  const dialogId = `usersGuideSpecialLinkDialog-${index}`
  const titleId = `${dialogId}-title`
  const dialog = document.createElement('dialog')
  dialog.id = dialogId
  dialog.className = 'sc21-UsersGuideSpecialLinkDialog'
  dialog.setAttribute('aria-labelledby', titleId)

  const linksHtml = preset.links
    .map(
      link => `
    <li>
      <a href="${link.url}" class="sc21-UsersGuideSpecialLinkDialog-link">
        <svg width="14" height="14" class="sc21-UsersGuideSpecialLinkDialog-linkBullet" aria-hidden="true"><use href="#sc21-arrowRightCircle"/></svg>
        <span class="sc21-UsersGuideSpecialLinkDialog-linkLabel">${link.label}</span>
      </a>
    </li>
  `
    )
    .join('')

  dialog.innerHTML = `
    <div class="sc21-UsersGuideSpecialLinkDialog-inner">
      <div class="sc21-UsersGuideSpecialLinkDialog-contents">
        <button type="button" class="sc21-UsersGuideSpecialLinkDialog-closeIconButton" aria-label="閉じる"></button>
        <div class="sc21-UsersGuideSpecialLinkDialog-contentsInner">
          <h2 id="${titleId}" class="sc21-UsersGuideSpecialLinkDialog-title">${preset.title}</h2>
          <ul class="sc21-UsersGuideSpecialLinkDialog-links">
            ${linksHtml}
          </ul>
        </div>
      </div>
    </div>
  `

  return dialog
}

// スクロールロック
function lockScroll() {
  document.documentElement.style.setProperty('overflow', 'hidden')
  document.body.style.setProperty('overflow', 'hidden')
}

function unlockScroll() {
  document.documentElement.style.removeProperty('overflow')
  document.body.style.removeProperty('overflow')
}

// CMSデータからプリセットにマッチするカードのhrefを解決する
function resolvePresetHrefs() {
  const indexData = window.__USERS_GUIDE_INDEX__
  if (!indexData) return []

  return presets
    .map(preset => {
      // 全カテゴリのitemsを走査してmatchIdに一致するカードを探す
      let matchedHref = null
      for (const category of indexData) {
        const item = category.items.find(item => item.id === preset.matchId)
        if (item) {
          // 外部リンクの場合はそのURL、内部リンクの場合は /creditcard/users-guide/{id}/
          matchedHref = item.externalPageRefer
            ? item.externalPageRefer.detailPageUrl
            : `/creditcard/users-guide/${item.id}/`
          break
        }
      }
      return { preset, matchedHref }
    })
    .filter(entry => entry.matchedHref !== null)
}

// hrefが解決済みのhrefにマッチするか判定
function matchesHref(href, targetHref) {
  if (!href || !targetHref) return false
  // 完全一致またはパス部分の一致で判定
  if (href === targetHref) return true
  try {
    const hrefUrl = new URL(href, window.location.origin)
    const targetUrl = new URL(targetHref, window.location.origin)
    return hrefUrl.pathname === targetUrl.pathname
  } catch {
    return false
  }
}

// 初期化
function init() {
  const container = document.getElementById('users-guide-index')
  if (!container) return

  // CMSデータからプリセットのhrefを解決
  const resolvedPresets = resolvePresetHrefs()
  if (resolvedPresets.length === 0) return

  // 各プリセットのダイアログをDOMに追加
  const presetDialogs = resolvedPresets.map(({ preset, matchedHref }, index) => {
    const dialog = createDialogElement(preset, index)
    document.body.appendChild(dialog)

    // 閉じるボタンのイベント
    dialog.querySelector('.sc21-UsersGuideSpecialLinkDialog-closeIconButton').addEventListener('click', () => {
      dialog.close()
    })

    // ESCキーなどで閉じた場合
    dialog.addEventListener('close', () => {
      unlockScroll()
    })

    // バックドロップクリック（コンテンツ外の暗い領域）で閉じる
    const innerEl = dialog.querySelector('.sc21-UsersGuideSpecialLinkDialog-inner')
    innerEl.addEventListener('click', e => {
      if (e.target === innerEl) {
        dialog.close()
      }
    })

    return { matchedHref, dialog }
  })

  // イベントデリゲーションでリンクのクリックを監視
  container.addEventListener('click', e => {
    const link = e.target.closest('a')
    if (!link) return

    const href = link.getAttribute('href')
    if (!href) return

    // 解決済みhrefにマッチするか確認
    const matched = presetDialogs.find(({ matchedHref }) => {
      return matchesHref(href, matchedHref)
    })

    if (matched) {
      e.preventDefault()
      // 既に開いている場合はスキップ（連続クリック対策）
      if (!matched.dialog.open) {
        matched.dialog.showModal()
        lockScroll()
      }
    }
  })
}

// DOMContentLoaded後に実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
